var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPwa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 11,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3D3D3D",
    d: "m19.871 8.345.78-1.973h2.253l-1.07-2.992L23.173 0 27 10.166h-2.823l-.655-1.821h-3.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5A0FC8",
    d: "M17.462 10.166 21.561 0h-2.717L16.04 6.57 14.046 0h-2.088L9.816 6.57l-1.51-2.994-1.366 4.209 1.387 2.38h2.675l1.934-5.89 1.846 5.89h2.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3D3D3D",
    d: "M2.58 6.676h1.673c.457.006.913-.05 1.354-.17l.433-1.333 1.21-3.728a2.933 2.933 0 0 0-.316-.414C6.314.344 5.404 0 4.208 0H0v10.166h2.58v-3.49Zm2.214-4.337c.243.244.364.57.364.98 0 .41-.107.737-.32.981-.233.27-.664.403-1.292.403H2.58v-2.73h.975c.584 0 .997.121 1.24.366Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h27v10.166H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwa);
export default __webpack_public_path__ + "static/media/PWA.dbe2caf8700ff19fd9451913cd03aac3.svg";
export { ForwardRef as ReactComponent };